<div class="container-lg">
    <div class="row">
        <h1 style="color: antiquewhite;">Bienvenido: </h1>
        <p style="color: darkgray; text-align: right;">{{currentUser.Name}}</p>
    </div>
    <div class="row">
        <div class="col-12 col-md-6">
            <ol>
                <li><a [routerLink]="['/Orders']" class="dashboardLink"><img src="../../../assets/icons8-shopping-cart-96.png">
                        Facturar</a></li>
                <li><a [routerLink]="['/Delivery']" class="dashboardLink"><img src="../../../assets/icons8-in-transit-96.png">
                        Despachar</a></li>
                <li><a [routerLink]="['/Tax']" class="dashboardLink"><img src="../../../assets/icons8-stack-of-money-96.png">
                        Cierre de Caja</a></li>
            </ol>
        </div>
        <div class="col-12 col-md-6">
            <ol>
                <li><a [routerLink]="['/Help']" class="dashboardLink"><img src="../../../assets/icons8-help-96.png"> Ayuda</a></li>
                <li><a (click)="onLogOut();" class="dashboardLink"><img src="../../../assets/icons8-logout-96.png"> Salir</a></li>
            </ol>
        </div>
    </div>
</div>